(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("AMapJS", [], factory);
	else if(typeof exports === 'object')
		exports["AMapJS"] = factory();
	else
		root["AMapJS"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 